import { Navigate, useLocation } from 'react-router-dom';
import { Login } from '../features/auth/pages/Login';
import { RestorePwd } from '../features/auth/pages/RestorePwd';
import { EmailPwdRestore } from '../features/auth/pages/EmailPwdRestore';

type PrivateRouteProps = {
  children: React.ReactNode;
};

const AuthRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const token = localStorage.getItem('token');
    const location = useLocation();
    // Permitir rutas p�blicas aunque haya token
    const publicPaths = ['/login', '/restore', '/restoreEmail', '/claimFollowUpPublic'];
    const isPublic = publicPaths.some(path => location.pathname.startsWith(path));

    if (token && !isPublic) {
        return <Navigate to="/dashboard" replace />;
    }

  return <>{children}</>;
};

export const publicRoutes = [
  {
    path: '/login',
        element: (
            <AuthRoute>
                <Login />
            </AuthRoute>
        ),
    },
    {
    path: '/restore/:uid/:language',
        element: (
            <RestorePwd />
        ),
    },
    {
        path: '/restoreEmail/:language',
        element: (
           <EmailPwdRestore />
        ),
    }
];
